import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { B } from '../constants';
import { getTripImageByDestination } from '../lib/tripImages';
import { blogs } from '../api';
import BlogRenderer from '../components/BlogRenderer';
import { planTripPath } from '../lib/planTrip';

export default function PublicBlogScreen() {
  const { tripId } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    blogs.getPublic(tripId)
      .then(setBlog)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [tripId]);

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>;
  if (error) return <div style={{ padding: 40, textAlign: 'center', color: 'red' }}>{error}</div>;
  if (!blog) return <div style={{ padding: 40, textAlign: 'center' }}>Blog not found</div>;

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 40 }}>
      <div style={{ background: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url(${blog.trip?.coverImage || 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1200'}) center/cover`, borderRadius: 20, padding: 40, color: 'white', marginBottom: 32 }}>
        <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 36, marginBottom: 8 }}>{blog.title}</h1>
        <p style={{ fontSize: 18, opacity: 0.9 }}>{blog.trip?.destination}</p>
        {blog.trip?.destination && (
          <a href={planTripPath(blog.trip.destination)}
            style={{ display: 'inline-block', marginTop: 16, background: B.amber, color: 'white', padding: '10px 20px', borderRadius: 20, fontWeight: 700, textDecoration: 'none', fontFamily: "'Montserrat',sans-serif" }}>
            ✈️ Plan this trip
          </a>
        )}
      </div>
      <BlogRenderer content={blog.content} experiences={blog.trip?.experiences || []} />

      {blog.trip?.experiences?.length > 0 && (
        <div style={{ marginTop: 40 }}>
          <h3 style={{ fontFamily: "'Montserrat',sans-serif", fontWeight: 700, fontSize: 18, marginBottom: 20, color: B.night }}>📍 Places Visited</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
            {blog.trip.experiences.map(exp => (
              <div key={exp.id} style={{
                background: B.sand,
                borderRadius: 14,
                overflow: 'hidden',
                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.06)'; }}
              >
                {exp.photos?.[0] && (
                  <img
                    src={exp.photos[0].url}
                    alt={exp.location || exp.title}
                    style={{ width: '100%', height: 140, objectFit: 'cover' }}
                    onError={(e) => {
                      const img = e.currentTarget;
                      if (img.dataset.fallback) return;
                      img.dataset.fallback = '1';
                      img.src = getTripImageByDestination(exp.location || exp.title || '');
                    }}
                  />
                )}
                <div style={{ padding: 14 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 14, color: B.night }}>{exp.title}</div>
                      {exp.location && <div style={{ fontSize: 12, color: B.muted, marginTop: 2 }}>📍 {exp.location}</div>}
                    </div>
                    <div style={{ fontSize: 12, color: B.amber, whiteSpace: 'nowrap', marginLeft: 8 }}>
                      {[1,2,3,4,5].map(r => (
                        <span key={r} style={{ color: r <= (exp.rating || 0) ? B.amber : '#ddd' }}>★</span>
                      ))}
                    </div>
                  </div>
                  {exp.content && (
                    <p style={{ fontSize: 12, color: '#666', lineHeight: 1.5, marginTop: 6 }}>{exp.content}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ marginTop: 40, padding: 20, background: '#f9f9f9', borderRadius: 12, textAlign: 'center' }}>
        <p style={{ color: B.muted, marginBottom: 12 }}>Plan your own trip like this!</p>
        <a href="/" style={{ background: B.forest, color: 'white', padding: '12px 24px', borderRadius: 20, textDecoration: 'none', fontWeight: 600 }}>
          Start Planning →
        </a>
      </div>
    </div>
  );
}
